import React, { useState } from "react";
import useSWR from "swr";
import { openNotification } from "../../common/elements/myNotification";
import { fetcherhn } from "../../services/fectcher";
import { WarningOutlined } from "@ant-design/icons";
import { deleteHospitalAdmission } from "../../api/CareEventSCPApi";
import {
  Button,
  Drawer,
  Popconfirm,
  Skeleton,
  Space,
  Table,
  Tooltip,
} from "antd";
import Search from "antd/es/input/Search";
import CareHospitalAdmissionAdd from "./CareHospitalAdmissionAdd";
import { FaEdit, FaMobileAlt, FaRegTrashAlt } from "react-icons/fa";
import { handleToggle } from "../../common/elements/toggleSeeMore";
import { useMyContext } from "../../common/elements/myContext";
import SendEmail from "../../common/elements/SendEmail";
import { FiSend } from "react-icons/fi";

const CareHospitalAdmission = (props) => {
  const initialReqState = {
    key: "",
    guid: "",
    mbi: props.mbiid,
    hospitalName: "",
    hospitalTelephone: "",
    hospitalAdmissionDate: "",
    hospitalAdmittingSymptoms: "",
    hospitalAttendingMDName: "",
    hospitalAttendingMDContact: "",
    hospitalCaseManagerName: "",
    hospitalCaseManagerContact: "",
    medxNotes: "",
    createdBy: sessionStorage.getItem("userName"),
    modifiedBy: "",
  };

  const [editRecord, setEditRecord] = useState(initialReqState);
  const [query, setQuery] = useState("");
  const { formatPhoneNumber } = useMyContext();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [mail, setMail] = useState(false);

  const sendDatatoEmail = (record) => {
    setMail(true);
    setEditRecord(record);
  };

  const { data, mutate, isLoading } = useSWR(
    `GetHospitalAdmissionTemplate?id=${props.mbiid}`,
    fetcherhn
  );

  const handleCancel = (e) => {
    setIsModalOpen(false);
    setEditRecord(initialReqState);
  };

  const handleModalClose = (e) => {
    setEditRecord(initialReqState);
    setMail(false);
  };

  const handleOk = async (e) => {
    if (e) {
      mutate();
    }
    setIsModalOpen(false);
    setEditRecord(initialReqState);
  };

  const edit = (record) => {
    setIsModalOpen(true);
    setEditRecord(record);
  };

  const handleDelete = async (record) => {
    const body = {
      ...record,
      modifiedBy: sessionStorage.getItem("userName"),
    };
    const deleteResult = await deleteHospitalAdmission(body);
    if (deleteResult.status) {
      mutate();
      openNotification(
        "success",
        "Deleted",
        "Hospital Admission Template Deleted Successfully!"
      );
    }
    setEditRecord(initialReqState);
  };

  const [expandedRows, setExpandedRows] = useState([]);

  const columns = [
    {
      key: 1,
      title: "Hospital Name/Telephone#",
      dataIndex: "hospitalName",
      render: (_, { hospitalName, hospitalTelephone }) => (
        <>
          <div>{hospitalName}</div>
          {hospitalTelephone ? (
            <div
              style={{
                fontSize: "0.9rem",
                color: "var(--bs-gray-600)",
                marginBottom: "0.3rem",
                marginTop: "0.3rem",
                overflowWrap: "break-word",
              }}
            >
              <FaMobileAlt
                size={20}
                style={{
                  color: "var(--bs-gray-500)",
                  marginRight: "0.5rem",
                  marginTop: "-2px",
                }}
              />
              <a href={`tel:${formatPhoneNumber(hospitalTelephone)}`}>
                {formatPhoneNumber(hospitalTelephone)}
              </a>
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },

    {
      key: 3,
      title: "Hospital Admission Date",
      dataIndex: "hospitalAdmissionDate",
    },
    {
      key: 4,
      title: "Hospital Admitting Symptoms / Dx",
      dataIndex: "hospitalAdmittingSymptoms",
    },
    {
      key: 5,
      title: "Hospital Attending MD Name / Contact#",
      dataIndex: "hospitalAttendingMDName",
      render: (_, { hospitalAttendingMDName, hospitalAttendingMDContact }) => (
        <>
          <div>{hospitalAttendingMDName}</div>
          {hospitalAttendingMDContact ? (
            <div
              style={{
                fontSize: "0.9rem",
                color: "var(--bs-gray-600)",
                marginBottom: "0.3rem",
                marginTop: "0.3rem",
                overflowWrap: "break-word",
              }}
            >
              <FaMobileAlt
                size={20}
                style={{
                  color: "var(--bs-gray-500)",
                  marginRight: "0.5rem",
                  marginTop: "-2px",
                }}
              />
              <a href={`tel:${formatPhoneNumber(hospitalAttendingMDContact)}`}>
                {formatPhoneNumber(hospitalAttendingMDContact)}
              </a>
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },

    {
      key: 7,
      title: "Hospital Case Manager Name / Contact#",
      dataIndex: "hospitalCaseManagerName",
      render: (_, { hospitalCaseManagerName, hospitalCaseManagerContact }) => (
        <>
          <div>{hospitalCaseManagerName}</div>
          {hospitalCaseManagerContact ? (
            <div
              style={{
                fontSize: "0.9rem",
                color: "var(--bs-gray-600)",
                marginBottom: "0.3rem",
                marginTop: "0.3rem",
                overflowWrap: "break-word",
              }}
            >
              <FaMobileAlt
                size={20}
                style={{
                  color: "var(--bs-gray-500)",
                  marginRight: "0.5rem",
                  marginTop: "-2px",
                }}
              />
              <a href={`tel:${formatPhoneNumber(hospitalCaseManagerContact)}`}>
                {formatPhoneNumber(hospitalCaseManagerContact)}
              </a>
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      key: 9,
      title: "MedEx Notes / Message",
      dataIndex: "medxNotes",
      width: 400,
      render: (text, record) => {
        const isExpanded = expandedRows.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );

        return <div>{content}</div>;
      },
    },
    {
      key: 10,
      title: "Created By",
      dataIndex: "createdBy",
      render: (createdBy) => <div>{createdBy.split("@")[0]}</div>,
    },
    {
      key: "key",
      title: "Operation",
      dataIndex: "guid",
      fixed: "right",
      width: 110,
      render: (_, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <FaEdit
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => edit(record)}
                color="blue"
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Ok to Delete?"
                onConfirm={() => handleDelete(record)}
                icon={
                  <WarningOutlined
                    style={{
                      color: "red",
                    }}
                  />
                }
              >
                <FaRegTrashAlt
                  size={20}
                  className=" tw-cursor-pointer"
                  color="red"
                />
              </Popconfirm>
            </Tooltip>
            <Tooltip title="Send Email">
              <FiSend
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => sendDatatoEmail(record)}
                color="green"
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const finalResult = data
    ? data.filter((item) => {
        return [
          "hospitalName",
          "hospitalTelephone",
          "hospitalAdmissionDate",
          "hospitalAdmittingSymptoms",
          "hospitalAttendingMDName",
          "hospitalAttendingMDContact",
          "hospitalCaseManagerName",
          "hospitalCaseManagerContact",
          "medxNotes",
          "createdBy",
        ].some((key) =>
          (item[key]?.toString()?.toLowerCase() ?? "").includes(
            query?.toLowerCase() ?? ""
          )
        );
      })
    : data;

  if (isLoading) {
    return <Skeleton active={isLoading} />;
  }

  return (
    <>
      <div className="tw-flex tw-justify-between ">
        <p
          className="pt-3"
          style={{
            color: "#D2691E",
            fontWeight: "600",
          }}
        >
          Hospital Admission Template
        </p>

        <div className="tw-flex tw-justify-end  tw-mt-3 ">
          <Space>
            <Search
              className=" tw-mb-4"
              size="middle"
              placeholder="Search"
              onChange={(e) => setQuery(e.target.value)}
              allowClear
            />
            <Button
              type="primary"
              onClick={() => setIsModalOpen(true)}
              className="tw-mb-4 "
            >
              Add
            </Button>
          </Space>
        </div>
      </div>
      {isModalOpen && (
        <Drawer
          open={isModalOpen}
          title={"Add/Update Hospital Admission Template"}
          onClose={handleCancel}
          width={900}
        >
          <CareHospitalAdmissionAdd
            callback={handleOk}
            editRecord={editRecord}
          />
        </Drawer>
      )}
      <Table
        bordered
        size="middle"
        dataSource={finalResult}
        columns={columns}
        virtual
        scroll={{
          x: 1500,
          y: 1000,
        }}
      />

      {mail && (
        <SendEmail
          open={mail}
          close={handleModalClose}
          editRecord={editRecord}
          modalTitle={"Hospital Admission Template"}
          patientName={props?.patient?.label}
        />
      )}
    </>
  );
};

export default CareHospitalAdmission;
